export enum PictureShape {
    SQUARE = 'square',
    HORIZONTAL_RECTANGLE = 'horizontal-rectangle',
    VERTICAL_RECTANGLE = 'vertical-rectangle'
}
